/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_DescriptionInputs */

const en_faq_description = /** @type {(inputs: Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We have put together some commonly asked questions`)
};

const es_faq_description = /** @type {(inputs: Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos reunido algunas preguntas frecuentes`)
};

/**
* | output |
* | --- |
* | "We have put together some commonly asked questions" |
*
* @param {Faq_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_description = /** @type {((inputs?: Faq_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_description(inputs)
	return en_faq_description(inputs)
});